import {ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { ConfigService } from '@services/config/config.service';
import {SearchResultsProcessor} from '@formbird/shared';
import {AvlAnimationGmapComponentDefinition} from './avl-animation-gmap.component.definition';
import {FormbirdInjectorService, SearchService} from 'formbird-services';
import {SclUtilAvlService, SclUtilGmapService} from 'formbird-sc-shared';
import {SclUtilMapService} from '../../../../formbird-mapping/src/lib/scl-util-map.service';
import * as GoogleMapsLoader from '../../../../formbird-mapping/src/lib/google/GoogleMapsLoader.js';
import * as moment from 'moment';
import {AbstractComponent} from '../../../../formbird-sc-shared/src/lib/components/abstract.component';
import {ComponentSetupService} from '../../../../formbird-sc-shared/src/lib/component-setup.service';
import {ChangedDocumentService} from 'formbird-services';

// import { AvlTestData } from './avl-test-data';

@Component({
  templateUrl: './avl-animation-gmap.component.html',
  styleUrls: [
    './avl-animation-gmap.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvlAnimationGmapComponent extends AbstractComponent<AvlAnimationGmapComponentDefinition> implements OnInit {

  @ViewChild('targetMap', {static: false}) target: ElementRef;
  // services
  notificationService: any;
  dataService: any;
  loggedInUserService: any;

  //
  google;
  map;
  // apiKey = 'AIzaSyDr8ovTk9O_JVvCokeaFE6nzsbhMRBCQm8'; // avl-dev server
  apiKey = 'AIzaSyDLF3KfOk7figOYUQAudATOTTqCbzf1ylc'; // localhost:3000
  mapParameters;
  defaultLat;
  defaultLon;
  defaultZoom;
  scheduleTimeDelay = 60000;
  scheduleTime = 12000;
  markersMap = {};
  tooltipConfig;
  vehicleMainImageFileField;
  vehicleShortNameField;
  vehicleIconFileField;
  previousPopup;
  geozonesQuery = '';
  geozonesData = '';
  geozonesName = '';
  listCars: any = [];
  vehicles = null;
  tooltipsTable;
  disableMouseWheel;
  movingTime;
  countCar = 0;
  samplePaths = {};
  firstPath = [];
  cars = [];
  toggleDebug = false;
  isDebug;
  isFocus = true;

  colorCar = [
    {duration: 30, color: '1'}, // seconds
    {duration: 60, color: '0.7'}, // seconds
    {duration: 120, color: '0.4'}, // seconds
    {duration: 240, color: '0.1'} // seconds
  ];
  CarPoint = {
    eventDate: {},
    coord: {},
    id: '',
    documentId: '',
    heading: 0
  };
  isTestMode = false;
  testLstData = [{coord:[152.306695, -24.898876]},{coord:[152.305226, -24.898829]},{coord:[152.303058, -24.898965]},
            {coord:[152.302179, -24.899082]},{coord:[152.301449, -24.899296]},{coord:[152.301299, -24.900367]},{coord:[152.300806, -24.903098]},
            {coord:[152.300505, -24.904902]},{coord:[152.300376, -24.906225]},{coord:[152.302586, -24.906575]},{coord:[152.304496, -24.906770]},
            {coord:[152.304882, -24.904473]},{coord:[152.30503, -24.903350]},{coord:[152.304937, -24.902906]},{coord:[152.30502, -24.902337]},
            {coord:[152.30528, -24.902001]}];
  testLstPos = [];
  testPosIdx: any;

  constructor(
    public cdRef: ChangeDetectorRef,
    protected changedDocumentService: ChangedDocumentService,
    protected componentSetupService: ComponentSetupService,
    protected formbirdInjectorService: FormbirdInjectorService,
    private sclUtilGmapService: SclUtilGmapService,
    private sclUtilMapService: SclUtilMapService,
    private sclUtilAvlService: SclUtilAvlService,
    private configService: ConfigService,
    private httpClient: HttpClient,
    private searchService: SearchService
  ) {
    super(formbirdInjectorService, changedDocumentService, componentSetupService, cdRef);
    this.notificationService = this.formbirdInjectorService.get('NotificationService');
    this.dataService = this.formbirdInjectorService.get('DataService');
    this.loggedInUserService = this.formbirdInjectorService.get('LoggedInUserService');
  }

  ngOnInit() {
    this.movingTime = this.scheduleTime;

    this.componentSetupService.setupStandardProperties(this);

    const clientConfig = this.configService.clientConfig();
    if (clientConfig && clientConfig.googleMapsKey) {
      this.apiKey = clientConfig.googleMapsKey;
    }

    if (!(typeof this.componentDefinition.avlVehiclesField === 'undefined' || this.componentDefinition.avlVehiclesField === null)) {
      this.vehicles = this.componentDefinition.avlVehiclesField;
    }
    if (!(typeof this.componentDefinition.vehicleIconFileField === 'undefined' || this.componentDefinition.vehicleIconFileField === null)) {
      this.vehicleIconFileField = this.componentDefinition.vehicleIconFileField;
    }
    if (!(typeof this.componentDefinition.tooltipsTable === 'undefined' || this.componentDefinition.tooltipsTable === null)) {
      this.tooltipsTable = this.componentDefinition.tooltipsTable;
    }
    if (!(typeof this.componentDefinition.image === 'undefined' || this.componentDefinition.image === null)) {
      this.vehicleMainImageFileField = this.componentDefinition.image;
    }
    if (!(typeof this.componentDefinition.vehicleShortNameField === 'undefined'
     || this.componentDefinition.vehicleShortNameField === null)) {
      this.vehicleShortNameField = this.componentDefinition.vehicleShortNameField;
    }
    if (!(typeof this.componentDefinition.geozones === 'undefined' || this.componentDefinition.geozones === null)) {
      if (this.componentDefinition.geozones.filter) {
        this.geozonesQuery = this.componentDefinition.geozones.filter;
      }
      if (this.componentDefinition.geozones.data) {
        this.geozonesData = this.componentDefinition.geozones.data;
      }
      if (this.componentDefinition.geozones.name) {
        this.geozonesName = this.componentDefinition.geozones.name;
      }
    }
    if (!(typeof this.componentDefinition.colorCar === 'undefined' || this.componentDefinition.colorCar === null)) {
      this.colorCar = this.componentDefinition.colorCar;
    }
    if (!(typeof this.componentDefinition.disableMouseWheel === 'undefined' || this.componentDefinition.disableMouseWheel === null)) {
        this.disableMouseWheel = this.componentDefinition.disableMouseWheel;
    }
    if (!(typeof this.componentDefinition.mapParameters === 'undefined' || this.componentDefinition.mapParameters === null)) {
        this.mapParameters = this.componentDefinition.mapParameters;
        if (this.mapParameters) {
            this.defaultLat = this.mapParameters.defaultLat;
            this.defaultLon = this.mapParameters.defaultLon;
            this.defaultZoom = this.mapParameters.zoom;
        }
    }

    this.setupChangeDetection();

    const avlVehiclesFieldSub = this.changedDocumentService.watch(this.componentDefinition.avlVehiclesField
        , this.document.documentId).subscribe(fieldValue => {
          console.log('watch avlVehiclesField, value = ' + fieldValue);
          this.document[this.componentDefinition.avlVehiclesField] = fieldValue;
          this.watchAvlVehiclesField(fieldValue);
    });
    this.subs.add(avlVehiclesFieldSub);

    this.loadMap(() => {
        console.log('GoogleMapsLoader loaded');
        if (typeof this.componentDefinition.heightNum === 'undefined' || this.componentDefinition.heightNum === null) {
          this.target.nativeElement.style.height = '180 px';
        } else {
          let height = 180 * this.componentDefinition.heightNum;
          const docHeight = document.body.scrollHeight;
          if (height > (docHeight - 180)) {
            height = docHeight - 180;
          }
          this.target.nativeElement.style.height = '' + height + 'px';
          const defaultLocation = { lat: this.defaultLat, lng: this.defaultLon };
          this.map = new this.google.maps.Map(this.target.nativeElement, {zoom: this.defaultZoom, center: defaultLocation});

          // create overlayview
          const overlay = new this.google.maps.OverlayView();
          overlay.onAdd = () => {
            overlay.getPanes().markerLayer.id = 'markerLayer';
          };
          overlay.setMap(this.map);
          this.map.addListener('zoom_changed', this.markersChange.bind(this));
          this.map.addListener('dragstart', this.markersChange.bind(this));
          this.map.addListener('click', () => {
              if (this.previousPopup) {
                  this.previousPopup.close();
              }
          });

          const MapLabel = this.sclUtilGmapService.initMapLabel(this.google);

          if (this.geozonesQuery && this.geozonesData) {
            // var options = scope.sclUtilMap.constructQueryVehicleData(imeis, scope.doc);
            const options = this.sclUtilMapService.constructQueryGeoZones(this.geozonesQuery, this.document);   // testing
            // getGeoZones
            this.searchService.search(options).then((data) => {
              console.log('getGeoZones result = ', data);
              this.sclUtilGmapService.getGeoCoors(SearchResultsProcessor, data, this.geozonesData, this.geozonesName, this.google
                , (geozones) => {
                  for (let i = 0 ; i < geozones.length; i++) {
                    const geozone = geozones[i];
                    if (geozone.shape === 'Point') {
                      const mapLabel: any = new MapLabel({
                              text: geozone.name,
                              position: geozone.coors[0],
                              map: this.map,
                              fontSize: 20
                        });
                      const marker = new this.google.maps.Marker({
                        position: geozone.coors[0]
                      });
                      marker.setMap(this.map);
                    } else if (geozone.shape === 'Line') {
                      if (this.geozonesName) {
                        const textCoor = this.centerOfZone(geozone.coors);
                        const mapLabel = new MapLabel({
                            text: geozone.name,
                            position: textCoor,
                            map: this.map,
                            fontSize: 20
                        });
                      }
                      const polyline = new this.google.maps.Polyline({
                        path: geozone.coors,
                        editable: false,
                        strokeColor: '#FF0000',
                        strokeOpacity: 1.0,
                        strokeWeight: 2
                      });
                      polyline.setMap(this.map);
                    } else if (geozone.shape === 'Polygon') {
                      if (this.geozonesName) {
                        const textCoor = this.centerOfZone(geozone.coors);
                        const mapLabel = new MapLabel({
                          text: geozone.name,
                          position: textCoor,
                          map: this.map,
                          fontSize: 20
                        });
                      }
                      const polyline = new this.google.maps.Polygon({
                        path: geozone.coors,
                        editable: false,
                        strokeColor: '#FF0000',
                        strokeOpacity: 1.0,
                        strokeWeight: 2
                      });
                      polyline.setMap(this.map);
                    } else {
                      console.log('not handles yet!!!');
                    }
                  }
                });
            });
          }

          setInterval(this.markersChange.bind(this), 1000);
          setInterval(this.update.bind(this), 20);
          this.getCars();
          setInterval(() => {
              if (this.isTestMode === true) {
                  this.updateCarsPositionTestMode();
              } else {
                  this.updateCarsPosition();
              }
          }, this.scheduleTime);
        }
    }); // end loadMap

    // test mode
    for (let i = 0, len = this.testLstData.length; i < len; ++i) {
      this.testLstPos.push( { _id: 'id_' + i, documentId: 'doc_' + i, coord: this.testLstData[i].coord } );
    }

  } // end ngOnInit


  loadMap(cb) {
    GoogleMapsLoader.KEY = this.apiKey;
    GoogleMapsLoader.LIBRARIES = 'places';
    GoogleMapsLoader.SENSOR = true;
    GoogleMapsLoader.load((google) => {
      this.google = google;
      cb();
    });
  }
  convertGPSToAddress(coor, cb) {
    const lat = parseFloat(coor[1]);
    const lon = parseFloat(coor[0]);

    const link = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + ',' + lon + '&key=' + this.apiKey;
    this.httpClient.get(link).subscribe((data: any) => {
        if (data.status === 'OK' ) {
          if (cb && typeof cb === 'function') {
            cb(data);
          }
        } else {
          console.log('Error: ' + data.error_message);
          cb(null);
        }
    }, error => {
      console.log('Error : ' + error);
      cb(null);
    });
  }
  lerp(v0, v1, t) {
    return v0 * (1 - t) + v1 * t;
  }

  // points A and B, frac between 0 and 1
  interpolate(a, b, frac) {
      const nx = a[0] + (b[0] - a[0]) * frac;
      const ny = a[1] + (b[1] - a[1]) * frac;
      return [nx, ny];

      // var line = new ol.geom.LineString([a, b]);
      // return line.getCoordinateAt(frac);
  }

  interpolateAngle(fromAngle, toAngle, t) {
      fromAngle = (fromAngle + 360) % 360;
      toAngle = (toAngle + 360) % 360;

      const diff = Math.abs(fromAngle - toAngle);
      if (diff < 180) {
        return this.lerp(fromAngle, toAngle, t);
      } else {
          if (fromAngle > toAngle) {
            fromAngle = fromAngle - 360;
            return this.lerp(fromAngle, toAngle, t);
            // return from;
          } else if (toAngle > fromAngle) {
            toAngle = toAngle - 360;
            return this.lerp(fromAngle, toAngle, t);
            // return from;
          }
      }
  }

  interpolateLatLng(points, frac) {
      const pointA = points[Math.floor(frac)];
      const pointB = points[Math.ceil(frac)];
      frac = frac - Math.floor(frac);

      const nx = pointA.lat() + (pointB.lat() - pointA.lat()) * frac;
      const ny = pointA.lng() + (pointB.lng() - pointA.lng()) * frac;
      return new this.google.maps.LatLng(nx, ny);

      // var line = new ol.geom.LineString([a, b]);
      // return line.getCoordinateAt(frac);
  }

  // *** class Car
  Car() {
    const name = '';
    const duration = 4000;
    const marker: any = {};
    const points = null;
    const endPoint: any = {};
    const startTime: any = {};
    const currentPath = null;
    const currentPathDraw = null;
    const debugCarRotation = null;
    const wholePath = null;
    const isFinished = true;
    const myName = 'car';
    const targetRotation = 0;
    const rotateSpeed = 1;
    const nextPoint: any = {};
    const lastMoveTimeStamp = null;
    const currentColor = null;
    const idcar = Math.random();
    const movingTime = 1500; // 10s
    const listDebug = [];

    const updateMovement = function(event) {
      this.updateColor();

      // this.debugCarRotation.getGeometry().setCoordinates(this.endPoint.coord);
      // this.debugCarRotation.getStyle().getImage().setRotation(this.endPoint.heading);

      if (this.isFinished) {
          this.checkNextPoint(0);
          return;
      }

      // var frameState = event.frameState;
      const time = event;
      const lineGeom = this.currentPath;



      const elapsed = time - this.startTime;
      let paths;
      if (elapsed >= this.movingTime) {
          paths = lineGeom.getPath().getArray();
          this.marker.setPosition(paths[paths.length - 1]);
          this.isFinished = true;
          // console.log(this.idcar +"   elapsed: "+elapsed+" movingTime  "+this.movingTime);
          this.checkNextPoint(elapsed - this.movingTime);
          return;
      }

      this.lastMoveTimeStamp = time;

      const t = elapsed / this.movingTime;
      paths = lineGeom.getPath().getArray();
      const point = this.interpolateLatLng(paths, t);
      this.marker.setPosition(point);


      // this.currentPathDraw.getGeometry().setCoordinates(lineGeom.getCoordinates());
      // this.currentPathDraw.getGeometry().setCoordinates([point, this.end]);

      // var next = lineGeom.getCoordinateAt(t + 0.05);
      // find the next point to define next heading
      let next; // = this.calculateNextPoint(elapsed);
      const t1 = t + 0.02;
      if (t1 >= 1) {
          next = this.calculateNextPoint(elapsed);
      } else {
          paths = lineGeom.getPath().getArray();
          next = this.interpolateLatLng(paths, t1);
      }

      this.nextPoint.setPosition(next);
      // this.currentPathDraw.getGeometry().setCoordinates([point, next]);

      const dlng = next.lng() - point.lng();
      const dlat = next.lat() - point.lat();

      if (Math.abs(dlng) <= 1e-8) {
          // this.marker.getStyle().getImage().setRotation(this.endPoint.heading);
          this.avlAnimationUtil.changeMarkerRotation(this.marker, this.endPoint.heading);
      } else {
          this.targetRotation = (-Math.atan2(dlat, dlng) + (Math.PI / 2.0)) * 180 / Math.PI;
          // if (this.targetRotation == -0) {
          //    this.targetRotation = 0;
          // }
          // setRotation
          const rotation = this.interpolateAngle(this.marker.rotation, this.targetRotation, 0.1);
          // this.marker.getStyle().getImage().setRotation(rotation);
          this.avlAnimationUtil.changeMarkerRotation(this.marker, rotation);
      }
    };
    const updateColor = function() {
        let selectColor = this.colorCar[this.colorCar.length - 1];

        let diff  = 0;
        const now = Date.now();
        const debugNow = new Date(now);

        if (this.lastMoveTimeStamp) {
            const lastMoveTimeStamp = new Date(this.lastMoveTimeStamp);
            diff = now - this.lastMoveTimeStamp;
            // logger.info('calculate diff time [1]: now: ' + (new Date(Date.now())) + ' - '
            //  +  (new Date(this.lastMoveTimeStamp)) + ' = ' + diff);
        } else {
            diff = now - this.endPoint.eventDate.getTime() - this.scheduleTimeDelay;
            // logger.info('calculate diff time [2]: now: ' + (new Date(Date.now())) + ' - '
            //  + (new Date(this.endPoint.eventDate.getTime())) + ' + '
            //    +  scheduleTimeDelay + ' = ' + diff);
        }

        const sec = diff / 1000;
        // console.log("sec = "+sec);
        // logger.info('diff time color: ' + sec);

        for (let i = 0; i < this.colorCar.length; ++i) {
            const c = this.colorCar[i];
            if (sec < c.duration) {
                selectColor = c;
                break;
            }
        }

        if (selectColor !== this.currentColor) {
            console.log('Change color: ' + selectColor);
            this.currentColor = selectColor;
            // this.marker.setStyle(this.createStyle(selectColor.color));
            this.avlAnimationUtil.changeMarkerColor(this.marker, selectColor);
        }
    };
    const calculateNextPoint = function(elapsed) {
        const timeCurrent = this.endPoint.eventDate - this.movingTime + elapsed;
        for (let i = 0; i < this.points.length; ++i) {
            const point = this.points[i];
            if (point.eventDate > timeCurrent) {
                return this.toLatLng(point.coord);
            }
        }
        return this.toLatLng(this.endPoint.coord);
    };
    const timeFormat = function(eventDate) {
        const  longDate = 'HH:mm:ss';
        const timeReturn =   moment(eventDate).format(longDate) ;
        return timeReturn;
    };
    const addPoint = function(newPoint) {
        let text = '';
        text += 'add:' + this.timeFormat(newPoint.eventDate);
        text += '  LocalDate:' + this.timeFormat(newPoint.eventDateLocal);
        text += '  SVDate:' + this.timeFormat(newPoint.eventDateOriginal);

        const mapLabel = new this.MapLabel({
            // text: data[i]._source[geozonesName],
            text: text,
            position: this.toLatLng(newPoint.coord),
            map: this.isDebug ? this.map : null,
            fontSize: 12,
            strokeWeight: 0,
            zIndex : 1
        });
        this.listDebug.push(mapLabel);
        this.points.push(newPoint);

        const coords = [];
        for (let i = 0; i < this.points.length; ++i) {
            coords.push(this.points[i].coord);
        }

        const paths = this.toListLatLng(coords);
        this.wholePath.setPath(paths);

        // update popup
        this.createTooltip(this.vehicleData, newPoint); // will call avl.addPoint after call this func
    };
    const checkNextPoint = function(deltaTime) {
        const points = this.points;
        if (points.length === 0) {
            if (this.endPoint) {
                this.changeMarkerRotation(this.marker, this.endPoint.heading);
            }
            return;
        }

        const timeBegin = this.endPoint.eventDate.getTime() + deltaTime;
        let idx = -1;
        for (let i = 0 ; i < points.length; i++) {
            if (points[i].id === this.endPoint.id && points[i].documentId === this.endPoint.documentId) {
                idx = i;
                break;
            }
        }
        let previousEndPointIdx = idx;

        if (idx > -1 && idx < points.length - 1) {
            let newEndPoint;

            for (let i = idx + 1, len = points.length; i < len; ++i) {
                const point = points[i];
                if (point.eventDate.getTime() > timeBegin) {
                    newEndPoint = point;
                    break;
                } else {
                    previousEndPointIdx = i;
                }
            }

            this.endPoint = this.points[previousEndPointIdx];
            // console.log("marker setposition" +toLatLng(this.endPoint.coord));
            this.marker.setPosition(this.toLatLng(this.endPoint.coord));

            // console.log("%c |-----> CheckNextPoint, newEndPoint" + JSON.stringify(newEndPoint), "color: green");

            if (newEndPoint) {
                const elapsedTime = timeBegin - this.endPoint.eventDate.getTime();
                const totalTime = newEndPoint.eventDate.getTime() - this.endPoint.eventDate.getTime();
                const t = elapsedTime / totalTime;
                const interpolatedEndpoint = this.interpolate(this.endPoint.coord, newEndPoint.coord, t);

                const endP = Object.create(this.CarPoint);
                endP.coord = interpolatedEndpoint;
                endP.eventDate = new Date(timeBegin);
                endP.id = this.endPoint.id;
                endP.documentId = this.endPoint.documentId;

                this.endPoint = endP;
                // console.log("marker setposition" +toLatLng(this.endPoint.coord));
                this.marker.setPosition(this.toLatLng(this.endPoint.coord));

                this.createPath(newEndPoint);
            } else {
                console.log('this case have not handle yet');
            }
        } else {
            this.changeMarkerRotation(this.marker, this.endPoint.heading);
        }
    };
    const createPath = function(endP) {
        const previousEndPoint = this.endPoint;
        this.endPoint = endP;
        const points = this.points;
        this.movingTime = this.endPoint.eventDate - previousEndPoint.eventDate;

        const pointsToMove = [this.marker.getPosition()];
        if (this.movingTime > this.scheduleTimeDelay) {
            this.movingTime = this.scheduleTimeDelay;
        }

        pointsToMove.push(this.toLatLng(endP.coord));
        this.startMovement(pointsToMove);
    };
    const startMovement = function(pointsToMove) {
        this.isFinished = false;

        this.start = pointsToMove[0];
        this.end = pointsToMove[pointsToMove.length - 1];

        const paths = pointsToMove;

        // this.currentPath.setCoordinates(pointsToMove);
        // console.log("=========setpaths: "+paths);
        this.currentPath.setPath(paths);

        this.startTime = Date.now();
        // this.calculateNewRotation(this.start, pointsToMove[1]);
        // this.calculateNewRotation(this.start, this.calculateNextPoint(0));
        // this.updateHeading();
    };
    const init = function(p) {

        const firstPoint = p.coord;
        this.endPoint = Object.create(this.CarPoint);
        this.endPoint.coord = firstPoint;
        this.endPoint.eventDate = p.eventDate;
        this.endPoint.eventDateOriginal = p.eventDateOriginal;
        this.endPoint.id = p.id;
        this.endPoint.documentId = p.documentId;
        this.endPoint.heading = p.heading;
        this.endPoint.speed = p.speed;
        this.points = [];


        const paths = this.toListLatLng([firstPoint, firstPoint]);
        this.currentPath = new this.google.maps.Polyline({
                path: paths,
                editable: false,
                strokeColor: '#FF0000',
                strokeOpacity: 1.0,
                strokeWeight: 2,
                zIndex: 20
            }
        );

        let src = '/api/getFile/d27b03a0-3369-11e8-ad4f-a3b4dc5f183b/car_up.png';

        if (this.vehicleIconFileField && this.vehicleData && this.vehicleData[this.vehicleIconFileField]
            && Array.isArray(this.vehicleData[this.vehicleIconFileField])
            && this.vehicleData[this.vehicleIconFileField].length > 0) {

            const imageData = this.vehicleData[this.vehicleIconFileField][0];
            src = '/api/getFile/' + imageData.fileNo + '/' + imageData.fileName;
        }
        // var icon ={
        //     url: src
        // };

        const latlng = this.toLatLng(firstPoint);
        const icon = {
            url: src,
            anchor: new this.google.maps.Point(30, 30),  // default anchor
            labelOrigin: new this.google.maps.Point(30, 70)
        };

        const shortName = this.vehicleShortNameField ? this.vehicleData[this.vehicleShortNameField] : ' ';
        this.marker = new this.google.maps.Marker({
            label:
                    {
                        text: shortName,
                        fontWeight: 'bold',
                        fontSize: '16px',
                        fontFamily: '"Courier New", Courier,Monospace',
                        color: 'black'
                    },
            icon : icon,
            position : latlng,
            map: this.map,
            zIndex: 20
        });

        this.nextPoint = new this.google.maps.Marker({
            position : latlng,
            zIndex: 15
        });


        this.wholePath = new this.google.maps.Polyline({
                path: paths,
                editable: false,
                strokeColor: '#0000FF',
                strokeOpacity: 1.0,
                strokeWeight: 2,
                zIndex: 10
            }
        );

        this.targetRotation =  this.marker.rotation;
        this.marker.set('movable', this);
        this.marker.set('myname', this.name);
        //

        this.changeMarkerRotation(this.marker, this.endPoint.heading);
        this.updateColor();



        this.createTooltip(this.vehicleData, this.endPoint);
    };
    const createTooltip = function(vehicleData, eventData) {
      // console.log("==========vehicleData");
      // console.log(vehicleData);
      // console.log("==========eventData");
      // console.log(eventData);

      let url = '';
      if (vehicleData.documentId) {
          url = 'form/' + vehicleData.documentId;
      }
      let imageUrl = '/api/getFile/562b8d70-5eb0-11e8-9d98-e5cdc65a95c1/garbage-truck.jpg';
      let imgtooltip = '';
      if (this.vehicleMainImageFileField && this.vehicleMainImageFileField
          && this.vehicleData[this.vehicleMainImageFileField]
          && Array.isArray(this.vehicleData[this.vehicleMainImageFileField])
          && vehicleData[this.vehicleMainImageFileField].length > 0) {

          const imageData = this.vehicleData[this.vehicleMainImageFileField][0];
          imageUrl = '/api/getFile/' + imageData.fileNo + '/' + imageData.fileName;
          imgtooltip = '<img src=' + imageUrl + '/>';
      }



      const name = '<a style=\"color:#2d24ff\" font-size=\"14px\" href=\"' + url + '\"><b>' + vehicleData.assetType
      + '</b></a><br>';

      const addressRow = this.toDataRow('Address', '');
      const gps = this.toDataRow('GPS', eventData.coord[0].toString() + ', ' + eventData.coord[1].toString());
      const time = this.toDataRow('Time', this.formatTime(eventData.eventDateOriginal));
      const speed = this.toDataRow('Speed', eventData.speed);
      const heading = this.toDataRow('Heading', eventData.heading);
      const imageRow = this.toDataRow('Image', imgtooltip);
      const arrayValue = [];
      arrayValue.push(addressRow);
      arrayValue.push(gps);
      arrayValue.push(time);
      arrayValue.push(speed);
      arrayValue.push(heading);

      if (this.tooltipConfig) {
          for (const key1 in this.tooltipConfig) {
              if (this.tooltipConfig.hasOwnProperty(key1)) {
                  const key2 = this.tooltipConfig[key1];
                  let value = this.sclUtilMapService.parseHandlerBar(key2, this.vehicleData) ;
                  value = value ? value : '';
                  const tooltipRow = this.toDataRow(key1, value);
                  arrayValue.push(tooltipRow);
              }

          }
      }

      arrayValue.push(imageRow);
      const text = this.toHtmlTable(arrayValue);


      const tooltip = name + text;
      const marker = this.marker;
      const self = this;
      if (!marker.infoWindow) {
          const infoWindow = new this.google.maps.InfoWindow({
              content: tooltip,
              disableAutoPan: false
          });

          marker.infoWindow = infoWindow;
          marker.addListener('click', function() {
              if (self.previousPopup) {
                  self.previousPopup.close();
              }

              // var anchor = new google.maps.Marker({
              //     position: this.getPosition(),
              //     map: scope.map,
              //     visible: false
              // });

              this.infoWindow.open(self.map, this);
              self.previousPopup = this.infoWindow;
          });
      } else {
          marker.infoWindow.setContent(tooltip);
      }

      this.convertGPSToAddress(eventData.coord, (data) => {
          if (marker.infoWindow) {
              const temp = {properties: {}};
              const address = this.sclUtilMap.fillGoogleAddress(data.data.results[0], temp);
              let text = (address.properties.streetNo) ? address.properties.streetNo : '';
              text += ' ' + ((address.properties.street) ? address.properties.street : '');
              text += '<br>' + ((address.properties.suburb) ? address.properties.suburb  : '');
              text += '<br> ' + ((address.properties.state) ? address.properties.state : '');
              text += ', ' + ((address.properties.country) ? address.properties.country : '');
              addressRow.col2 = text;
              const arrayValue = [];
              arrayValue.push(addressRow);
              arrayValue.push(gps);
              arrayValue.push(time);
              arrayValue.push(speed);
              arrayValue.push(heading);

              if (this.tooltipConfig) {
                  for (const key1 in this.tooltipConfig) {
                      if (this.tooltipConfig.hasOwnProperty(key1)) {
                          const key2 = this.tooltipConfig[key1];
                          let value = this.sclUtilMap.parseHandlerBar(key2, vehicleData) ;
                          value = value ? value : '';
                          const tooltipRow = this.toDataRow(key1, value);
                          arrayValue.push(tooltipRow);
                      }

                  }
              }

              arrayValue.push(imageRow);
              const text1 = name + this.toHtmlTable(arrayValue);
              marker.infoWindow.setContent(text1);
          }

      });

    };
  } // end Car

  // begin mCar
  mCar() {
    const documentId = '';
    const imei = '';
    const car = null;
    const paths = [];
    const checkPoint = {};
    const firstTime = true;
    const self = this;

    const init = function(pDocumentId, pNewPoints, pImei, pVehicleData) {
        this.car = new this.Car();
        this.car.vehicleData = pVehicleData;
        this.car.name = 'Car_' + pDocumentId;
        this.car.documentId = pDocumentId;
        this.car.marker.myname = this.car.name;
        this.car.imei = pImei;
        this.imei = pImei;
        this.documentId = pDocumentId;

        this.initListPoint(pNewPoints);


    };
    const animate = function(event) {
        this.car.updateMovement(event);
    };

    const initListPoint = function(newPoints) {
        if (newPoints.length === 0) {
          console.log('no event data.........');
        }


        // process data here
        // compare with current date time
        // last date is valid if  300s with local date
        // if invalid getlastevent -> black car
        // is valid
            // get more event in 30s
            // make move

        this.currentDate = new Date();
        this.firstPoint = newPoints[0];
        this.diff = Math.abs(this.currentDate - this.firstPoint.eventDateOriginal);
        if (this.diff > 300000) {
            const carPoint: any = {};

            carPoint.coord = this.firstPoint.coord;
            carPoint.eventDateOriginal = this.firstPoint.eventDateOriginal;
            carPoint.eventDateLocal = new Date();
            carPoint.speed = this.firstPoint.speedKPH;
            carPoint.id = this.firstPoint.id;
            carPoint.documentId = this.firstPoint.documentId;
            carPoint.heading = this.firstPoint.heading;
            carPoint.heading_degree = this.firstPoint.heading;

            carPoint.eventDate = new Date();
            carPoint.eventDate.setMilliseconds(carPoint.eventDate.getMilliseconds() - 300000);

            this.checkPoint = carPoint;
            this.car.init(carPoint);
            this.paths.push(carPoint);
            const coord1 = self.toLatLng(carPoint.coord);
            self.map.setCenter(coord1);
        } else {
            const validPoints = [];
            const currentDate: any = new Date(newPoints[0].eventDateOriginal);
            for (let i = 0; i < newPoints.length; i++) {
                const eventDate: any = new Date(newPoints[i].eventDateOriginal);
                const diff = Math.abs(currentDate - eventDate);

                validPoints.push(newPoints[i]);
                // if diff > delaytime, add last point and break loop
                if ( diff > self.scheduleTimeDelay) {
                    break;
                }
            }

            // if lenght = 1   add current event
            if (validPoints.length === 1) {
                const carPoint: any = {};
                const firstPoint = validPoints[0];
                carPoint.coord = firstPoint.coord;
                carPoint.eventDateOriginal = firstPoint.eventDateOriginal;
                carPoint.eventDateLocal = new Date();
                carPoint.speed = firstPoint.speedKPH;
                carPoint.id = firstPoint.id;
                carPoint.documentId = firstPoint.documentId;
                carPoint.heading = firstPoint.heading;
                carPoint.heading_degree = firstPoint.heading;

                carPoint.eventDate = new Date();
                carPoint.eventDate.setMilliseconds(carPoint.eventDate.getMilliseconds() - 30000);

                this.checkPoint = carPoint;
                this.car.init(carPoint);
                this.paths.push(carPoint);
                const coord2 = self.toLatLng(carPoint.coord);
                self.map.setCenter(coord2);
            } else { // else lenght > 1 add list point
                const firstEventDate = validPoints[validPoints.length - 1].eventDateOriginal;
                const deltaTimeOriginal = validPoints[0].eventDateOriginal - firstEventDate;
                // localtime/servertime
                const timeScale = self.scheduleTimeDelay / deltaTimeOriginal;

                for (let i = validPoints.length - 1; i >= 0; i--) {
                    const newPoint: any = validPoints[i];
                    const carPoint: any = {};
                    carPoint.coord = newPoint.coord;
                    carPoint.eventDateOriginal = newPoint.eventDateOriginal;
                    carPoint.eventDateLocal = new Date();
                    carPoint.speed = newPoint.speedKPH;
                    carPoint.id = newPoint.id;
                    carPoint.documentId = newPoint.documentId;
                    carPoint.heading = newPoint.heading;
                    carPoint.heading_degree = newPoint.heading;

                    // carPoint.eventDate = new Date();
                    const deltaTimeOriginal1 = newPoint.eventDateOriginal - firstEventDate;
                    const deltaTime = deltaTimeOriginal1 * timeScale - self.scheduleTimeDelay;
                    carPoint.eventDate = new Date();
                    carPoint.eventDate.setMilliseconds(carPoint.eventDate.getMilliseconds()+ deltaTime);

                    if ( i === validPoints.length - 1) {
                        this.checkPoint = carPoint;
                        this.car.init(carPoint);
                        this.paths.push(carPoint);
                        const coord1 = self.toLatLng(carPoint.coord);
                        self.map.setCenter(coord1);
                    } else {
                        this.addPoint(carPoint);
                    }
                        // console.log("first point: " + JSON.stringify( car_point) );
                }
            }
        }

    };

    const addListPoint = function(newPoints) {
        if (!newPoints || newPoints.length === 0) {
          return;
        }
        const currentDate: any = new Date();
        let deltaTimeLocal = currentDate - this.checkPoint.eventDateLocal;
        let idleTime = 0;
        if (deltaTimeLocal > self.scheduleTimeDelay) {
            idleTime = deltaTimeLocal - self.scheduleTimeDelay;
        }
        deltaTimeLocal = Math.min( self.scheduleTimeDelay, deltaTimeLocal);

        const deltaTimeOriginal = newPoints[newPoints.length - 1].eventDateOriginal - this.checkPoint.eventDateOriginal;
        if (newPoints.length > 1) {
            console.log('points.length = ' + newPoints.length);
        }
        for (let i = 0; i < newPoints.length; i++) {
            const newPoint = newPoints[i];
            newPoint.eventDateLocal = new Date();
            const timeScale = deltaTimeLocal / deltaTimeOriginal;
            const deltaTimeOriginal1 = newPoint.eventDateOriginal - this.checkPoint.eventDateOriginal;
            const deltaTimeLocal1 = deltaTimeOriginal1 * timeScale;
            const timeStartMove =  new Date(this.checkPoint.eventDate);
            timeStartMove.setMilliseconds(timeStartMove.getMilliseconds() + deltaTimeLocal1);
            if (i === 0 && idleTime > 0) {
              timeStartMove.setMilliseconds(timeStartMove.getMilliseconds() + idleTime);
            }
            newPoint.eventDate = new Date(timeStartMove);

            if (!newPoint.eventDate) {
              console.log('invalid date');
            }
            this.addPoint(newPoint);
        }
    };

    const addPoint = function(newPoint) {
        const carPoint: any = {};
        carPoint.coord = newPoint.coord;
        carPoint.eventDateOriginal = newPoint.eventDateOriginal;
        carPoint.eventDateLocal = newPoint.eventDateLocal;
        carPoint.eventDate = newPoint.eventDate;
        carPoint.speed = newPoint.speedKPH;
        carPoint.id = newPoint.id;
        carPoint.documentId = newPoint.documentId;
        carPoint.heading = newPoint.heading;
        carPoint.heading_degree = newPoint.heading;

        if (this.firstTime) {
            if (this.paths.length > 0) {

                const firstPoint = this.paths[0];
                const diff = Math.abs(carPoint.eventDate - firstPoint.eventDate);
                this.checkPoint = carPoint; // store check point for the next check time

                // var idx = this.paths.findIndex(a => a.id == carPoint.id);//check if id of new_point is duplicate
                let idx = -1;
                for (let i = 0; i < this.paths.length; i++) {
                  if (this.paths[i].id === carPoint.id) {
                    idx = i;
                    break;
                  }
                }
                if (diff >= self.scheduleTimeDelay) {// if last time over delay time then pass old point to car
                    // this.checkPoint = carPoint;//store check point for the next check time
                    if (idx < 0) {
                      this.paths.push(carPoint); // if new_point is not exist in paths
                    }

                    for (let i = 0, len = this.paths.length; i < len; ++i) {
                        // var j = this.car.points.findIndex(a => a.id == this.paths[i].id);
                        let j = -1;
                        for ( let h = 0; h < this.car.points.length; h++) {
                            if (this.car.points[h].id === this.paths[i].id) {
                                j = h;
                                break;
                            }
                        }
                        if (j > -1) { continue; }
                        this.car.addPoint(this.paths[i]);
                    }

                    this.paths = []; // reset
                    console.log('%c |-----> add tat ca diem vao xe, this.paths.len = ' + this.paths.length
                        + ', car.len = ' + this.car.points.length, 'color: blue');
                    this.firstTime = false;
                } else if (idx < 0) { // if no over delay time
                    this.paths.push(carPoint);
                }
            } else {
                console.log('not handle yet!!!!');
                // var diff = Math.abs(carPoint.eventDate - this.checkPoint.eventDate);
                // console.log("diff 2 = " + diff + ", check_point = " + this.checkPoint.eventDate);

                // if (diff >= scheduleTimeDelay) {
                //     if (this.car.points && this.car.points.length > 0) {
                //         var i = this.car.points.findIndex(a => a.id == carPoint.id
                //     )
                //         ;
                //         if (i < 0) this.car.addPoint(carPoint);
                //     }
                //     else this.car.addPoint(carPoint);
                //     this.checkPoint = carPoint;
                //     this.firstTime = false;
                // }
                // else {
                //     if (this.car.points && this.car.points.length > 0) {
                //         var i = this.car.points.findIndex(a => a.id == carPoint.id
                //     )
                //         ;
                //         if (i < 0) this.paths.push(carPoint);
                //     }
                //     else this.paths.push(carPoint);
                // }
            }
        } else {
            if (this.car.points && this.car.points.length > 0) {
                // var i = this.car.points.findIndex(a => a.id == carPoint.id);
                let idx = -1;
                for (let i = 0; i < this.car.points[i].id; i++) {
                    if (i < this.car.points[i].id === carPoint.id) {
                        idx = i;
                        break;
                    }
                }
                if (idx < 0) {
                    this.car.addPoint(carPoint);
                    this.checkPoint = carPoint;
                }
            }
        }
        // console.log("current path len = " + this.paths.length);

    };
  } // end mCar

  toLatLng(point) {
    return new this.google.maps.LatLng(point[1], point[0]);
  }

  latlngToArray(latlng) {
      return [latlng.lng, latlng.lat];
  }

  toListLatLng(points) {
      const latlngs = [];
      for (let i = 0 ; i < points.length; i++) {
          latlngs.push(this.toLatLng(points[i]));
      }
      return latlngs;
  }

  markersChange(markersMap) {
    const markersLoading = [];
    for (const key in markersMap ) {
        if (markersMap.hasOwnProperty(key)) {
            if (!this.isVisible( markersMap[key].img) ) {
                markersLoading.push(markersMap[key]);
            }
        }
    }

    if (markersLoading.length > 0) {
        const listImgElement = document.querySelectorAll('#markerLayer img');
        // console.log(listImgElement);

        for (let i = 0; i < listImgElement.length; i++) {
            const element: any = listImgElement[i];
            for (const key1 in markersLoading ) {
                if (markersLoading.hasOwnProperty(key1)) {
                    if (element.__src__ === markersLoading[key1].icon.url && !element.id) {
                        element.id = 'marker' + key1;
                        element.style.transform = 'rotate(' + markersLoading[key1].rotation + 'deg)';
                        markersLoading[key1].img = element;
                        if (markersLoading[key1].rotation) {
                            this.changeMarkerRotation(markersLoading[key1], markersLoading[key1].rotation);
                        }
                        if (markersLoading[key1].color) {
                            this.changeMarkerColor(markersLoading[key1], markersLoading[key1].color, markersMap);
                        }
                    }
                }

            }
        }
    }
  }
  changeMarkerColor(marker, color, markersMap) {
    let element = marker.img;
    if ( color === undefined) {
        return;
    }
    if (!this.isVisible(element)) {
        this.markersChange(markersMap);
        element = marker.img;
    }
    if (this.isVisible(element)) {
        const newstype = 'brightness(' + color.color + ')';
        element. style.filter = newstype;
        console.log('color stype ' + newstype);
        if (marker.icon.size) {
            marker.icon.anchor = new this.google.maps.Point(marker.icon.size.width / 2,marker.icon.size.height / 2);
        }
    }
    marker.color =  color;
  }
  changeMarkerRotation(marker, rotation) {
    const element = marker.img;
    if (rotation === undefined) {
        return;
    }
    if (!this.isVisible(element)) {
        // markersChange();
        // element = marker.img;
    }
    if (this.isVisible(element) ) {
        element.style.transform = 'rotate(' + rotation + 'deg)';
        if (marker.icon.size) {
            marker.icon.anchor = new this.google.maps.Point(marker.icon.size.width / 2, marker.icon.size.height / 2);
        }


    }
    marker.rotation =  rotation;
  }
  isVisible(element) {
      if (element && element.offsetParent) {
          return true;
      }
      return false;
  }
  formatTime(time) {
      const  longDate = 'MMM DD YYYY, h:mm:ss a';
      const timeReturn = moment(time).fromNow() + ' (' + moment(time).format(longDate) + ')';
      return timeReturn;
  }
  toDataRow(col1, col2) {
      const row: any = {};
      row.col1 = col1;
      row.col2 = col2;
      return row;
  }

  toHtmlTable(array) {
      const style = '';
      let tableText = '<table style="width:100%" class = "table-popup">';
      for (let i = 0; i < array.length; i++) {
          tableText += '<tr>';
          tableText += '<td class = "table-popup">' + array[i].col1 + '</td>';
          tableText += '<td class = "table-popup">' + array[i].col2 + '</td>';
          tableText += '</tr>';
      }
      tableText += '</table>';
      return tableText;
  }
  centerOfZone(coordinates) {
    let lat = 0;
    let lng = 0;
    if (coordinates.length <= 0) {
      return;
    }
    for (let i = 0; i < coordinates.length; i++) {
      lat = lat + coordinates[i].lat();
      lng = lng + coordinates[i].lng();
    }
    return new this.google.maps.LatLng(lat / coordinates.length, lng / coordinates.length);
  }
  addCar(documentId, newPoints, imei, vehicleData) {

    const car = new this.mCar();
    // console.log("scope.add, car = " + car);

    car.init(documentId, newPoints, imei, vehicleData);
    if (this.cars.length > 0) {
        // var idx = cars.findIndex( a => a.documentId == documentId);
        let idx = -1;
        for (let i = 0; i < this.cars.length; i++) {
            if (this.cars[i].documentId === documentId) {
                idx = i;
                break;
            }
        }
        if (idx > -1) {
            this.mapRemoveCar(this.toggleDebug, this.cars[idx].car);
            this.cars.splice(idx, 1);
        }
    }
    this.cars.push(car);

    this.mapAddCar(this.toggleDebug, car.car);
    if (this.markersMap[documentId]) {

    } else {
        this.markersMap[documentId] = car.car.marker;
    }

  }
  mapRemoveCar(isDebug, oldCar) {
    const features = this.listCars;
    let hasRemove = false;
    for (let i = 0, len = features.length; i < len; i++) {
        const feature = features[i];
        // console.log("feature " + i + " = ");
        // console.log(feature);
        if (feature.myname === oldCar.name) {
            console.log('find feature');
            this.listCars.removeFeature(feature);
            hasRemove = true;
            break;
        }
    }

  }
  mapAddCar(isDebug, car) {
    if (this.toggleDebug) {
        this.listCars.push(car.marker);
    } else {
        this.listCars.push(car.marker);
    }
  }
  deepCloneArray(array) {
    const retVal = [];
    for (let i = 0; i < array.length; ++i) {
        const item = array[i];
        const carPoint = Object.create(this.CarPoint);
        carPoint.coord = item.coord;
        carPoint.eventDate = item.eventDate;
        retVal.push(carPoint);
    }
    return retVal;
  }
  animate(event) {
    let i;
    for (i = 0; i < this.cars.length; ++i) {
        const car = this.cars[i];
        car.animate(event);
    }
  }
  setDebug(val) {
    this.toggleDebug = !val;
    this.isDebug = this.toggleDebug;
    this.isTestMode = this.toggleDebug;

    if (this.toggleDebug) {
        for (let i1 = 0, len1 = this.cars.length; i1 < len1; ++i1 ) {
            const param1 = this.cars[i1];
            const car1: any = param1.car;
            car1.currentPath.setMap(this.map);
            car1.nextPoint.setMap(this.map);
            car1.wholePath.setMap(this.map);

            for (const id1 in car1.listDebug) {
                if (car1.listDebug.hasOwnProperty(id1)) {
                    car1.listDebug[id1].setMap(this.map);
                }
            }
        }
    } else {
        for (let i = 0, len = this.cars.length; i < len; ++i ) {
            const param = this.cars[i];
            const car = param.car;
            car.currentPath.setMap(null);
            car.nextPoint.setMap(null);
            car.wholePath.setMap(null);
            for (const id in car.listDebug) {
                if (car.listDebug.hasOwnProperty(id)) {
                    car.listDebug[id].setMap(null);
                }
            }
        }
    }
  }
    update() {
        this.animate(Date.now());
    }
    getContentText(eventDate) {
        return '' + this.formatTime(eventDate );
    }
    // load cars with documentId & selected date ( all name is 'searchEvent' )
    getCars() {
        if (this.componentDefinition == null || this.componentDefinition.avlVehiclesField == null) { return; }
        const vehicles = this.document[this.componentDefinition.avlVehiclesField];
        if (vehicles == null || vehicles.length === 0) { return; }

        for (let i = 0, len = vehicles.length; i < len; ++i) {
            const documentId = vehicles[i].documentId;
            this.getCar(documentId);
        }
    }
    getCar(documentId) {
        const params = {
            functionName: 'getLastEvent',
            componentDocumentName: 'sc-avl-animation-gmap',
            functionParameters: [this.componentDefinition.dataService, documentId]
        };
        this.httpClient.post('api/execute', params).subscribe((dataResult: any) => {
            console.log('apiGetLastEvent , result data = ');
            console.log(dataResult);
            const data = dataResult.data;
            if (data && data.length > 0) {
                const vehicleRel: any = this.sclUtilAvlService.getRelatedDocument(data[0], 'vehicle');

                if (vehicleRel && vehicleRel.documentId) {
                    const newPoints = [];
                    const carDocumentId = vehicleRel.documentId;
                    for (let i = 0; i < data.length; i++) {
                        newPoints.push(this.processData(data[i]));
                    }
                    const options = this.sclUtilMapService.constructQueryDocument([carDocumentId], this.document);
                    this.searchService.search(options)
                    .then( (results) => {
                        const result = results.data.hits.hits;
                        console.log('getVehicleData -> ');
                        console.log(result);
                        if (result && result.length > 0) {
                            const source = result[0]._source;

                            this.addCar(documentId, newPoints, data[0].imeis, source);

                        }
                    }, (err) => {
                      console.error('error options when getting vehicles data :' + options.filter);
                      console.error(err);
                    });
                }
            }
        }, (err) => {
            console.error('error query current location :');
            console.error(err);
        });
    }
    removeCar(documentId) {
        // var idx = cars.findIndex(x=> x.documentId == documentId);
        let idx = -1;
        for (let i = 0 ; i < this.cars.length; i++) {
            if (this.cars[i].documentId === documentId) {
                idx = i;
            }
        }
        if (idx >= 0) {
            this.cars[idx].car.wholePath.setMap(null);
            this.cars[idx].car.currentPath.setMap(null);
            this.cars[idx].car.marker.setMap(null);
            this.cars[idx].car.nextPoint.setMap(null);

            delete this.cars[idx];
            this.cars.splice(idx, 1);
        }
    }
    processData(customData) {
        const item = customData;

        const object: any = {};
        const feature = item.locationGeo.features[0];
        // coor
        object.coord = feature.geometry.coordinates;

        const properties = feature.properties;

        const serverDate = new Date(item.eventDate);
        object.eventDateOriginal = serverDate;
        object.id = item._id;
        object.documentId = item.documentId;
        object.heading = item.heading; // * Math.PI / 180.0;

        object.speedKPH = item.speedKPH;

        return object;
    }
    // get position of all cars
    updateCarsPosition() {
        if (this.cars.length === 0 || (!this.isFocus && !this.isDebug)) { return; }
        const timeUpdate = new Date();
        console.log('updateCarsPosition' + timeUpdate);

        for (let i = 0; i < this.cars.length; ++i) {
            const car = this.cars[i];
            const x = i;
            const documentId = car.documentId;
            const timeOfLastEvent = car.checkPoint.eventDateOriginal;
            const params = {
                functionName: 'getListEventAfterTime',
                componentDocumentName: 'sc-avl-animation-gmap',
                functionParameters: [this.componentDefinition.dataService, documentId, timeOfLastEvent]
            };
            // apiGetListEventAfterTime
            this.httpClient.post('api/execute', params).subscribe((dataResult: any) => {
                console.log(dataResult);
                let vehicle;
                const data = dataResult.data;
                const newPaths = [];
                if (data && data.length > 0) {
                    for (let j = 0; j < data.length; j++) {
                        vehicle = this.sclUtilAvlService.getRelatedDocument(data[j], 'vehicle');
                        const newPath = this.processData(data[j]);
                        for (let h1 = 0; h1 < this.cars.length; h1++) {
                            if (vehicle.documentId === this.cars[h1].documentId) {
                                newPaths.push(newPath);
                            }
                        }
                    }
                }
                for (let h = 0; h < this.cars.length; h++) {
                    if (vehicle && vehicle.documentId === this.cars[h].documentId) {
                        this.cars[h].addListPoint(newPaths);
                    }
                }
            });
        }

    }
    updateCarsPositionTestMode() {
        if (this.cars.length === 0 || (!this.isFocus && !this.isDebug)) { return; }

        for (let i = 0; i < this.cars.length; ++i) {
            const point = [];
            const iRandom = Math.floor((Math.random() * 10) + 1);
            if (iRandom < 5) {
                const pos1 = this.testLstPos[this.testPosIdx];
                point.push({coord: pos1.coord
                    , eventDateOriginal: new Date()
                    , id: pos1._id
                    , documentId: pos1.documentId});

                if (this.testPosIdx < this.testLstPos.length - 1) {
                    this.testPosIdx++;
                } else {
                    this.testPosIdx = 0;
                    const d1: number = Date.now();
                    for (let j1 = 0, len1 = this.testLstPos.length; j1 < len1; ++j1 ) {
                        this.testLstPos[j1]._id = 'id_' + j1 + '_' + d1.toString();
                        this.testLstPos[j1].documentId = 'doc_' + j1 + '_' + d1.toString();
                    }
                }
                this.cars[i].addListPoint(point);
            } else if (iRandom < 7)  {
                let pos = this.testLstPos[this.testPosIdx];
                const eventDateOriginal = new Date();
                eventDateOriginal.setMilliseconds(eventDateOriginal.getMilliseconds()
                - ((Math.random() * 0.5 + 0.25) * this.scheduleTime) );
                point.push({coord: pos.coord
                    , eventDateOriginal: eventDateOriginal
                    , id: pos._id
                    , documentId: pos.documentId});

                if (this.testPosIdx < this.testLstPos.length - 1) {
                    this.testPosIdx++;
                } else {
                    this.testPosIdx = 0;
                    const d2: number = Date.now();
                    for (let j2 = 0, len2 = this.testLstPos.length; j2 < len2; ++j2 ) {
                        this.testLstPos[j2]._id = 'id_' + j2 + '_' + d2.toString();
                        this.testLstPos[j2].documentId = 'doc_' + j2 + '_' + d2.toString();
                    }
                }
                pos = this.testLstPos[this.testPosIdx];
                point.push({coord: pos.coord
                    , eventDateOriginal: new Date()
                    , id: pos._id
                    , documentId: pos.documentId});

                if (this.testPosIdx < this.testLstPos.length - 1) {
                    this.testPosIdx++;
                } else {
                    this.testPosIdx = 0;
                    const d = Date.now();
                    for (let j = 0, len = this.testLstPos.length; j < len; ++j ) {
                        this.testLstPos[j]._id = 'id_' + j + '_' + d.toString();
                        this.testLstPos[j].documentId = 'doc_' + j + '_' + d.toString();
                    }
                }
                this.cars[i].addListPoint(point);
            }
        }



    }

    watchAvlVehiclesField(value) {
        console.log('watchAvlVehiclesField, value = ' + value);
        const tempVehicles = value;
        if (this.vehicles && tempVehicles) {
            for (let i = 0; i < tempVehicles.length; i++) {
                // var index = vehicles.findIndex(x => x.documentId == tempVehicles[i].documentId);
                let index = -1;
                for (let j = 0; j < this.vehicles.length; j++) {
                    if (this.vehicles[j].documentId === tempVehicles[i].documentId) {
                        index = j;
                        break;
                    }
                }
                if (index < 0) {
                    // new cars
                    this.getCar(tempVehicles[i].documentId);
                }
            }


            for (let i = 0; i < this.vehicles.length; i++) {
                // var index = tempVehicles.findIndex(x => x.documentId == vehicles[i].documentId);
                let index = -1;
                for (let j = 0; j < tempVehicles.length; j++) {
                    if (tempVehicles[j].documentId === this.vehicles[i].documentId) {
                        index = j;
                        break;
                    }
                }
                if (index < 0) {
                    // vehicleId has been remove
                    this.removeCar(this.vehicles[i].documentId);
                }
            }
        }
        this.vehicles = tempVehicles;
    }

  showToolTip(tooltip: any, formFieldContainer: any, labelContainer: any) {
    return (labelContainer.offsetWidth <= formFieldContainer._elementRef.nativeElement.scrollWidth);
  }

  toggleTooltip(tooltip: any) {
    setTimeout(() => {
      tooltip.toggle();
    });
  }
}
